import { DataAttributeDefinitions } from 'scrivito'

import { pisaMyWorkContactRelationDataClass } from './Pisa/pisaMyWorkContactRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const MyWorkContactRelation =
  pisaMyWorkContactRelationDataClass(attributes)
